module.exports = __webpack_public_path__ + "img/p-16.902e8d94.png";